import React from 'react';

function WhyChooseUsSection() {
  const styles = {
    section: {
      padding: '80px 48px 48px', background: '#fff', position: 'relative'
    },
    subheadingRow: {
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, marginBottom: 8
    },
    dashLine: {
      width: 150, height: 0, borderTop: '2px solid #E73123', flexShrink: 0
    },
    subheading: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '26px', lineHeight: '100%',
      letterSpacing: '-0.01em', textAlign: 'center', textTransform: 'uppercase',
      color: '#090909', margin: 0
    },
    titleWrap: { textAlign: 'center', marginBottom: 20 },
    titleRed: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textAlign: 'center', textTransform: 'uppercase', color: '#E73123'
    },
    titleBlack: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textAlign: 'center', textTransform: 'uppercase', color: '#090909'
    },
    contentWrap: {
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      position: 'relative', minHeight: 480, margin: '0 auto', maxWidth: 900
    },
    gearWrap: {
      display: 'flex', justifyContent: 'center', alignItems: 'center'
    },
    gearImg: {
      width: 750, height: 750, maxWidth: '95vw', maxHeight: '75vh', objectFit: 'contain', display: 'block',
      filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.12))'
    }
  };

  return React.createElement('section', { style: styles.section },
    React.createElement('div', { style: styles.subheadingRow },
      React.createElement('div', { style: styles.dashLine }),
      React.createElement('h2', { style: styles.subheading }, 'WHY CHOOSE US'),
      React.createElement('div', { style: styles.dashLine })
    ),
    React.createElement('div', { style: styles.titleWrap },
      React.createElement('div', null,
        React.createElement('span', { style: styles.titleRed }, 'THE STRENGTH '),
        React.createElement('span', { style: styles.titleBlack }, 'BEHIND EVERY'),
        React.createElement('br'),
        React.createElement('span', { style: styles.titleBlack }, 'SUCCESSFUL PROJECT')
      )
    ),
    React.createElement('div', { style: styles.contentWrap },
      React.createElement('div', { style: styles.gearWrap },
        React.createElement('img', { src: '/Gear.png', alt: 'Why choose us', style: styles.gearImg })
      )
    )
  );
}

export default WhyChooseUsSection;
